import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const InteractiveFloorplanStyles = styled.div`
  @media only screen and (min-width: ${tablet_breakpoint}px) {
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
  }
`;

export const OuterContainer = styled.div`
  box-sizing: border-box;
  font-family: 'acumin-pro', sans-serif;
  height: 100vh;
  min-height: 525px;
  overflow-x: hidden;
  position: relative;

  * {
    box-sizing: border-box;
  }
`;

export const BlackoutDiv = styled.div`
  display: none;

  &.open {
    background-color: rgba(0, 0, 0, 0.65);
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 5;
  }

  @media not all and (min-resolution: 0.001dpcm) {
    /* Safari 10.1+ */
    &.open {
      height: 100vh;
      width: 100vw;
    }
  }
  @media (max-width: 970px) {
    display: block;
  }
`;

export const InnerContainer = styled.div`
  background-color: #efefef;
  height: 100%;
  overflow: hidden;
  margin-left: 386px;
  position: relative;

  .mobile-cta {
    display: none;
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 2;

    @media (max-width: 970px) {
      display: block;
    }
  }

  @media (max-width: 970px) {
    margin-left: 0;
    padding-bottom: 220px;
  }
`;

export default InteractiveFloorplanStyles;
